// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ContainerControl } from './ContainerControl';
import AccountSelectorTemplate from '@front/templates/AccountSelectorTemplate.html';
import { AccountMenuItemsHelper } from '@shared/commons/AccountWidget/AccountMenuItemsHelper';
import { DataCache } from '@shared/commons/DataCache';
import { AccountWidgetAccountsController } from '@shared/commons/AccountWidget/AccountWidgetAccountsController';
import { TerceraLookupEvents } from './Lookup/TerceraLookup';
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
export class AccountSelector extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.AccountSelector;
    }
    oncomplete() {
        const IsOnlyOwnAccounts = AccountMenuItemsHelper.GetDataToFillOut(null, false).IsOnlyOwnAccounts;
        const isLookupForAccounts = this.get('isMultiSelectMode') || !IsOnlyOwnAccounts;
        if (!this.get('visible')) {
            return;
        }
        const visible = DataCache.getNumberOfAccounts() > 1;
        void this.set({ isLookupForAccounts });
        const ignoreForceLinkingByAccount = this.get('ignoreForceLinkingByAccount');
        const enableForceLinkingByAccount = DataCache.EnableForceLinkingByAccount();
        if (enableForceLinkingByAccount && (!ignoreForceLinkingByAccount || IsOnlyOwnAccounts)) {
            void this.set({ visible: false });
        }
        else {
            void this.set({ visible });
        }
        this.setStartValue(ignoreForceLinkingByAccount, enableForceLinkingByAccount);
        this.observe('selectedItem', this.onSelectedItemChanged, { init: false });
    }
    getLookup() {
        return this.Controls.accountLookup;
    }
    getComboBox() {
        return this.Controls.combobox;
    }
    setStartValue(ignoreForce, enableForce) {
        if (!ignoreForce)
            return;
        const onlyOwnAccounts = this.get('onlyOwnAccounts');
        const accs = onlyOwnAccounts && enableForce ? DataCache.getOwnedAccounts() : DataCache.getAccounts();
        const acc = AccountWidgetAccountsController.Account;
        if (!isNullOrUndefined(accs[acc.AcctNumber])) {
            void this.set('selectedItem', acc);
        }
        else {
            void this.set('selectedItem', DataCache.getPrimaryAccount());
        }
    }
    onSelectedItemChanged(newValue, oldValue) {
        this.fire(TerceraLookupEvents.SelectedItemChanged, newValue);
    }
}
ContainerControl.extendWith(AccountSelector, {
    template: AccountSelectorTemplate,
    data: function () {
        return {
            selectedItem: null,
            isLookupForAccounts: false,
            enabled: true,
            ignoreForceLinkingByAccount: false,
            onlyOwnAccounts: false,
            visible: true,
            excludeMultiAsset: false,
            isMultiSelectMode: false // TMP, always TerceraAccountLookup show
        };
    }
});
